<!--
 * @Author: 张天昊
 * @Date: 2024-05-17 11:24:46
 * @LastEditTime: 2025-04-15 15:22:50
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @Description: 基础信息头
 * @FilePath: /Gov-Web/Mobile/src/pages/itineraryUniversal/components/BasicInfoHeader.vue
-->
<script>
import { defineComponent, ref, computed } from 'vue';
import CopyButton from './CopyButton.vue';
import QrCodeLauncher from './QrCodeLauncher.vue';
import PrimaryTag from './PrimaryTag.vue';
import NormalTag from './NormalTag.vue';
import BasicInfoCard from './BasicInfoCard.vue';
import Description from './Description.vue';
import FeatureTag from './FeatureTag.vue';
import BaseInfoRemark from './BaseInfoRemark.vue';
import { navigateToTouristsView } from '../navigate';
import { TouristAgeTypes, TeamBusiTypeMap } from '../constants';
import store from '@/store';

export default defineComponent({
  components: {
    CopyButton,
    QrCodeLauncher,
    PrimaryTag,
    NormalTag,
    BasicInfoCard,
    Description,
    FeatureTag,
    BaseInfoRemark
  },
  setup() {
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );

    const computedQrcode = computed(() => {
      if (!detailInfo.value) {
        return '';
      }
      if (detailInfo.value.itineraryInfoMessage.qrcodePath) {
        return detailInfo.value.itineraryInfoMessage.qrcodePath;
      }
      if (detailInfo.value.itineraryInfoMessage.qrcodeDate) {
        // 沿用pc端逻辑，认为这个raw base64就是png格式的图片
        return `data:image/png;base64,${detailInfo.value.itineraryInfoMessage.qrcodeDate}`;
      }
      return '';
    });

    const computedTouristsNumber = computed(() => {
      if (!detailInfo.value) {
        return '';
      }
      let count = `${detailInfo.value.itineraryInfoMessage.numberPeople}`;
      // const oldmanCount = detailInfo.value.itineraryTouristMessage.filter(
      //   (item) => item.ageType === TouristAgeTypes.老人
      // ).length;
      // if (oldmanCount > 0) {
      //   count += `（需重点关注${oldmanCount}人）`;
      // }
      return count;
    });

    

    return {
      TeamBusiTypeMap,
      detailInfo,
      computedQrcode,
      computedTouristsNumber,
      pickTouristsIntoView: () => navigateToTouristsView()
    };
  }
});
</script>

<template>
  <div v-if="detailInfo" class="relative px-12 pt-12 pb-16 bg-green-primary">
    <div class="flex text-white">
      <span class="text-20 leading-24 font-semibold flex-auto">{{
        detailInfo.itineraryInfoMessage.routeName
      }}</span>
      <span class="text-14 leading-22 font-medium flex-shrink-0 ml-9">{{
        detailInfo.itineraryInfoMessage.checkStateStr
      }}</span>
    </div>
    <div class="flex items-center text-white mt-7 text-12 leading-20">
      <div class="flex-1 flex items-center">
        <span>行程单号：{{ detailInfo.itineraryInfoMessage.teamId }}</span>
        <CopyButton
          :value="detailInfo.itineraryInfoMessage.teamId"
          class="ml-8"
        />
      </div>
      <QrCodeLauncher
        :value="computedQrcode"
      />
    </div>
    <div
      class="mt-16 pr-34 flex items-center flex-wrap"
      :style="{ rowGap: $px2rem(8) }"
    >
      <PrimaryTag
        class="mr-4"
        :type="detailInfo.itineraryInfoMessage.teamType"
      />
      <NormalTag
        class="mr-4"
        :type="detailInfo.itineraryInfoMessage.teamBusiType"
        :name="TeamBusiTypeMap.get(detailInfo.itineraryInfoMessage.teamBusiType)"
        :tags="
          detailInfo.itineraryInfoMessage.includeItemsCn
            ? detailInfo.itineraryInfoMessage.includeItemsCn.split('、')
            : []
        "
      />
      <span class="inline-flex items-center">
        <!-- <FeatureTag
          v-if="
            detailInfo.insuranceList &&
            detailInfo.insuranceList.length &&
            detailInfo.insuranceList[0].buyText !== '未购买'
          "
          >保险已购买</FeatureTag
        > -->
        <FeatureTag v-if="detailInfo.itineraryInfoMessage.hasContract"
          >合同已上传</FeatureTag
        >
      </span>
    </div>
    <BasicInfoCard class="mt-14" />
    <div class="flex items-center mt-16 pl-12 pr-8 pt-12 pb-12 bg-[#1C8C5E] text-white text-12 rounded-4" @click="pickTouristsIntoView">
      <!-- <Description
        theme="light"
        label="参团游客人数"
        size="small"
        :content="computedTouristsNumber"
      />
      <span
        class="ml-6 text-14 leading-20 text-white inline-flex items-center van-haptics-feedback"
        @click="pickTouristsIntoView"
        >全部<span
          class="bg-green-a ml-3 w-12 h-12 rounded-full inline-flex justify-center items-center"
          ><svg-icon
            pre-path="itineraryUniversal"
            name="ic-arrow"
            class="w-10 h-10 stroke-white" /></span
      ></span> -->

      <div class="flex-col text-white border-r-1 pr-8 rounded-tl-4 ">
          <div class="mb-2">参团游客数</div>
          <div ><span class="text-22"> {{ computedTouristsNumber }}</span><span>人</span> </div>
      </div>
      <div class="flex-1 self-stretch flex-col ml-16">
        <div class="mb-10">保险购买方式：{{ detailInfo.itineraryInfoMessage.insuranceBuyerStr }}</div>
        <div class="inline-flex gap-4">
          保险购买状态：<van-icon name="checked" size="12" color="#ffffff" v-if="detailInfo.itineraryInfoMessage.checkState == 2"/>{{ detailInfo.itineraryInfoMessage.insuranceStatusStr }} 
        </div>
      </div>
      <div>
        <van-icon name="arrow" color="#ffffff"  size="16"/>
      </div>

    </div>
    <BaseInfoRemark />
    <!-- <QrCodeLauncher
      :value="computedQrcode"
      class="absolute z-1 right-12 top-54"
    /> -->
  </div>
</template>
